/* eslint-disable consistent-return */
import { createAsyncThunk } from '@reduxjs/toolkit';
import create from '../../../services/api';
import API_PATH from '../../../constant/apiPath';
import { updateLoading } from '../loader';

// Define fetchLogout thunk
// const fetchLogout = createAsyncThunk('authentication/logout', async (data: any, { dispatch }) => {
//   const API = create();
//   try {
//     dispatch(updateLoading(true));
//     const response:any = await API.post(API_PATH.USER, data); // Adjust `any` to the correct type if known
//     dispatch(updateLoading(false));
//     localStorage.clear();
//     return response.data;
//   } catch (err) {
//     return Promise.reject(err); // Return as rejected promise to signal failure in createAsyncThunk
//   }
// });

// Define fetchLogin thunk
const fetchLogin = createAsyncThunk('authentication/login', async (data: any, { dispatch, getState }) => {
  const API = create();
  console.log('getState', getState());
  try {
    dispatch(updateLoading(true));
    const response:any = await API.get(API_PATH.LOGIN, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    return Promise.reject(err); // Return as rejected promise
  }
});

const fetchVerification = createAsyncThunk('authentication/verification', async (data: any, { dispatch, getState }) => {
  const API = create();
  console.log('getState', getState());
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.VERIFICATION, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise
  }
});

export {
  // fetchLogout,
  fetchLogin,
  fetchVerification
};
